import React from 'react';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Nutzungsbedingungen</h1>
        
        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <p className="text-sm text-gray-500">Stand: Januar 2026</p>
          
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Geltungsbereich</h2>
            <p>
              Diese Nutzungsbedingungen gelten für die Nutzung der Wisecall-Plattform 
              ("Dienst"), einem KI-gestützten Telefonassistenten-Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Leistungsbeschreibung</h2>
            <p>Wisecall bietet folgende Dienste:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Erstellung und Verwaltung von KI-Telefonagenten</li>
              <li>Automatische Anrufbearbeitung (Inbound)</li>
              <li>Automatische Outbound-Kampagnen</li>
              <li>Termin-Erinnerungen via Google Kalender Integration</li>
              <li>Transkription und Speicherung von Anrufen</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Registrierung und Konto</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Für die Nutzung ist eine Registrierung erforderlich</li>
              <li>Sie sind für die Geheimhaltung Ihrer Zugangsdaten verantwortlich</li>
              <li>Die Angabe falscher Daten kann zur Sperrung führen</li>
              <li>Ein Konto ist nicht übertragbar</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Nutzungsrechte und -pflichten</h2>
            <p><strong>Sie dürfen:</strong></p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Den Dienst für geschäftliche Zwecke nutzen</li>
              <li>Agenten für Ihr Unternehmen erstellen</li>
              <li>Anrufe aufzeichnen (unter Beachtung lokaler Gesetze)</li>
            </ul>
            <p><strong>Sie dürfen nicht:</strong></p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Den Dienst für illegale Zwecke nutzen</li>
              <li>Spam-Anrufe oder belästigende Nachrichten versenden</li>
              <li>Die Sicherheitsmaßnahmen umgehen oder manipulieren</li>
              <li>Den Dienst an Dritte weiterverkaufen</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Preise und Zahlung</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Die aktuellen Preise finden Sie auf unserer Preisseite</li>
              <li>Die Abrechnung erfolgt monatlich über Stripe</li>
              <li>Gesprächsminuten werden entsprechend Ihres Plans abgerechnet</li>
              <li>Bei Zahlungsverzug kann der Zugang gesperrt werden</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Google Kalender Integration</h2>
            <p>
              Bei Nutzung der Google Kalender Integration:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Gewähren Sie uns nur Lesezugriff auf Ihre Kalender</li>
              <li>Die Verbindung kann jederzeit getrennt werden</li>
              <li>Wir nutzen die Daten ausschließlich für Termin-Erinnerungen</li>
              <li>Es gelten zusätzlich die Google APIs Terms of Service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">7. Haftung</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Wir haften nicht für Ausfälle der Drittanbieter (Twilio, OpenAI, Google)</li>
              <li>Die KI-generierten Inhalte werden ohne Gewähr bereitgestellt</li>
              <li>Für indirekte Schäden oder entgangenen Gewinn haften wir nicht</li>
              <li>Unsere Haftung ist auf den monatlichen Vertragswert begrenzt</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">8. Kündigung</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Sie können Ihr Konto jederzeit kündigen</li>
              <li>Bei Verstoß gegen diese Bedingungen können wir das Konto sperren</li>
              <li>Nach Kündigung werden Ihre Daten innerhalb von 30 Tagen gelöscht</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">9. Änderungen</h2>
            <p>
              Wir behalten uns vor, diese Nutzungsbedingungen zu ändern. 
              Über wesentliche Änderungen werden Sie per E-Mail informiert.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">10. Schlussbestimmungen</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Es gilt deutsches Recht</li>
              <li>Gerichtsstand ist der Sitz des Anbieters</li>
              <li>Sollten einzelne Bestimmungen unwirksam sein, bleibt der Rest gültig</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">11. Kontakt</h2>
            <p>
              Bei Fragen zu diesen Nutzungsbedingungen:<br />
              E-Mail: hello@wisecall.de
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-200">
          <a href="/" className="text-emerald-600 hover:text-emerald-700 font-medium">
            ← Zurück zur Startseite
          </a>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
